/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.Attribute = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var DataUtils_1 = __importDefault(require("./utils/DataUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'Attribute';
exports.name = name;

var Attribute = function Attribute(components) {
  var Frame = components.Frame,
      Text = components.Text,
      Property = components.Property,
      ColorPicker = components.ColorPicker,
      styles = components.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);

      if (props.Property) {
        Property = props.Property;
      }

      _this.determineType = _this.determineType.bind(_assertThisInitialized(_this));
      _this.renderProperties = _this.renderProperties.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "determineType",
      value: function determineType(attribute) {
        var validTypes = ['radio', 'check', 'color'];

        if (attribute.type && validTypes.indexOf(attribute.type) > -1) {
          return attribute.type;
        }

        if (attribute.required) {
          return 'radio';
        }

        return 'check';
      }
    }, {
      key: "renderProperties",
      value: function renderProperties(attribute, propertyIds) {
        var _this$props = this.props,
            propertyComponents = _this$props.propertyComponents,
            select = _this$props.select;
        var type = this.determineType(attribute);

        if (type === 'color') {
          return react_1.default.createElement(ColorPicker, {
            attribute: attribute,
            select: select
          });
        }

        return propertyIds.map(function (id) {
          if (propertyComponents && propertyComponents[id]) {
            var Component = components[propertyComponents[id]];
            return react_1.default.createElement(Component, {
              key: id,
              propertyId: id,
              select: select
            });
          }

          switch (type) {
            case 'radio':
              return react_1.default.createElement(Property, {
                type: "radio",
                key: id,
                propertyId: id,
                select: select
              });

            case 'check':
            default:
              return react_1.default.createElement(Property, {
                type: "check",
                key: id,
                propertyId: id,
                select: select
              });
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _a, _b, _c, _d, _e;

        var _this$props2 = this.props,
            after = _this$props2.after,
            attribute = _this$props2.attribute,
            before = _this$props2.before,
            classes = _this$props2.classes,
            lastSelectedAttribute = _this$props2.lastSelectedAttribute,
            propertyIds = _this$props2.propertyIds;

        if ((attribute === null || attribute === void 0 ? void 0 : attribute.active) === false) {
          return react_1.default.createElement(react_1.default.Fragment, null);
        }

        var style = Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.container), (_a = attribute === null || attribute === void 0 ? void 0 : attribute.style) === null || _a === void 0 ? void 0 : _a.container);

        if ((attribute === null || attribute === void 0 ? void 0 : attribute.id) === lastSelectedAttribute) {
          Object.assign(style, styles === null || styles === void 0 ? void 0 : styles.highlighted);
        }

        return react_1.default.createElement(Frame, {
          className: ['Attribute__container', classes === null || classes === void 0 ? void 0 : classes.container, _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.highlighted) || '', (attribute === null || attribute === void 0 ? void 0 : attribute.id) === lastSelectedAttribute)],
          style: style
        }, before, attribute && react_1.default.createElement(Frame, {
          className: ['Attribute__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.inner), (_b = attribute === null || attribute === void 0 ? void 0 : attribute.style) === null || _b === void 0 ? void 0 : _b.inner)
        }, ((_c = attribute.display) === null || _c === void 0 ? void 0 : _c.hideTitle) !== true && react_1.default.createElement(Text, {
          className: classes === null || classes === void 0 ? void 0 : classes.title,
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.title), (_d = attribute === null || attribute === void 0 ? void 0 : attribute.style) === null || _d === void 0 ? void 0 : _d.title)
        }, attribute.name), (attribute === null || attribute === void 0 ? void 0 : attribute.description) && react_1.default.createElement(Text, {
          className: ['Attribute__description', classes === null || classes === void 0 ? void 0 : classes.description],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.description), (_e = attribute === null || attribute === void 0 ? void 0 : attribute.style) === null || _e === void 0 ? void 0 : _e.description)
        }, attribute.description), this.renderProperties(attribute, propertyIds)), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Attribute = Attribute;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _a;

  var attributeId = ownProps.attributeId;
  var api = state.api,
      ui = state.ui;
  var lastSelectedAttribute = ui.lastSelectedAttribute;
  var db = new BrightsmithDb(api);
  var attribute = db.getAttribute(attributeId);
  var properties = (_a = attribute === null || attribute === void 0 ? void 0 : attribute.properties) === null || _a === void 0 ? void 0 : _a.map(function (propId) {
    return db.getProperty(propId);
  });
  var propertyIds = DataUtils_1.default.sort(properties).map(function (p) {
    return p.id;
  });
  return {
    attribute: attribute,
    lastSelectedAttribute: lastSelectedAttribute,
    propertyIds: propertyIds
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d;

  return {
    container: Object.assign({}, theme === null || theme === void 0 ? void 0 : theme.Attribute.container),
    description: Object.assign({
      fontSize: 14,
      lineHeight: '18px',
      marginLeft: 45,
      marginBottom: 15,
      paddingRight: 38
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Attribute) === null || _a === void 0 ? void 0 : _a.description),
    highlighted: Object.assign({}, (_b = theme === null || theme === void 0 ? void 0 : theme.Attribute) === null || _b === void 0 ? void 0 : _b.highlighted),
    inner: Object.assign({}, (_c = theme === null || theme === void 0 ? void 0 : theme.Attribute) === null || _c === void 0 ? void 0 : _c.inner),
    title: Object.assign({
      fontWeight: '600',
      fontSize: 13,
      marginLeft: 45,
      marginTop: 12,
      marginBottom: 12
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.Attribute) === null || _d === void 0 ? void 0 : _d.title)
  };
};

exports.style = style;